import { Injectable, inject, signal, DestroyRef } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { OidcSecurityService } from 'angular-auth-oidc-client';
import { Router } from '@angular/router';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { NotificationService } from '../services/notification.service';

@Injectable({
  providedIn: 'root'
})
export class AuthService {
  private oidcSecurityService = inject(OidcSecurityService);
  private router = inject(Router);
  private notificationService = inject(NotificationService);
  private translateService = inject(TranslateService);
  private destroyRef = inject(DestroyRef);

  isAuthenticated = signal(false);
  private wasAuthenticated = false;

  initialize(): void {
    this.oidcSecurityService.isAuthenticated$.pipe(takeUntilDestroyed(this.destroyRef)).subscribe(({ isAuthenticated }) => {
      if (this.wasAuthenticated && !isAuthenticated) {
        this.handleSessionExpired();
      }
      this.isAuthenticated.set(isAuthenticated);
      this.wasAuthenticated = isAuthenticated;
    });
  }

  private handleSessionExpired(): void {
    this.notificationService.error(this.translateService.instant('NOTIFICATIONS.ERROR.SESSION_EXPIRED'));
    this.router.navigate(['/login']);
  }

  logout(): void {
    this.oidcSecurityService.logoff().subscribe();
  }
}
